import { useFetchContentQuery } from "@marketing-site/api/urbana/contentful/apiSlice";
import { CulturePageQuery } from "@marketing-site/api/urbana/contentful/queries/culture.query";
import { Header } from "@marketing-site/components";
import Footer from "@whopper/footer";
import { SEO } from "@marketing-site/components/_contentful";
import HeroCulture from "@marketing-site/components/_contentful/hero/HeroCulture";
import { IHeroProductAlias } from "@marketing-site/components/_contentful/hero/HeroProduct";
import { NavigationBar } from "@marketing-site/components/navbar/NavigationBar";
import { IContentChild } from "@marketing-site/types/shared.model";
import { mapComponents } from "@marketing-site/utils";
import React, { Fragment } from "react";
import { useLocation, useParams } from "react-router-dom-v5-compat";
import styled from "styled-components";
import { LoadingPage } from "../Page/LoadingPage";

export interface ICultureProps {
  locale?: string;
  "*"?: string;
}

export const Culture = () => {
  const pageData: ICultureProps = useParams();
  const location = useLocation();
  const locale = pageData.locale || "en";
  const path = location.pathname;
  const suffix = pageData["*"];
  const slug = "culture" + (suffix ? `/${suffix}` : "");

  const {
    data: contentfulData,
    error: contentfulError,
    isLoading: contentfulLoading,
  } = useFetchContentQuery({
    query: CulturePageQuery(slug, locale),
    space: "hopperCom",
  });

  const getBody = () => {
    if (contentfulLoading || !contentfulData) {
      return <LoadingPage />;
    } else {
      // @ts-ignore: Need to figure out types for responses coming from contentful
      const page = contentfulData;
      const children = page.contentCollection.items.map(
        (child: IContentChild<any>) => child
      );

      const culturePageMap = {
        HeroProduct: (props: React.PropsWithChildren<IHeroProductAlias>) => {
          return <HeroCulture {...props} />;
        },
      };

      const childComponents = mapComponents(children, slug, culturePageMap);
      return (
        <>
          <SEO {...page.seo} locale={locale} canonical={path} />
          <NavigationBar contentfulNavProps={page.navigation} />
          <Body>
            {childComponents.map((component, i) => {
              return <Fragment key={i}>{component}</Fragment>;
            })}
          </Body>
          <Footer {...page.navigation.footer} />
        </>
      );
    }
  };

  return <React.Fragment>{getBody()}</React.Fragment>;
};

const NavHeader = styled(Header)`
  position: relative;
  z-index: 20;
`;

const Body = styled.div`
  position: relative;
  z-index: 10;
`;
